// @flow
import type { Action } from '../../../state/types'

export type RegisterPayload = {
  name: string,
  dogName: string,
  age: string,
  sex: string,
  breed: string,
  houseNo: string,
  villageNo: string,
  lane: string,
  road: string,
  subDistrict: string,
  district: string,
  province: string,
  zipcode: string,
  tel: string,
  email: string,
}

const id = 'gbiProject/REGISTER'

export const register = (
  name: string,
  dogName: string,
  age: string,
  sex: string,
  breed: string,
  houseNo: string,
  villageNo: string,
  lane: string,
  road: string,
  subDistrict: string,
  district: string,
  province: string,
  zipcode: string,
  tel: string,
  email: string,
): Action<RegisterPayload> => ({
  type: id,
  payload: {
    name,
    dogName,
    age,
    sex,
    breed,
    houseNo,
    villageNo,
    lane,
    road,
    subDistrict,
    district,
    province,
    zipcode,
    tel,
    email,
  },
})

register.id = id
